import isFQDN from 'validator/es/lib/isFQDN';
import toString from 'lodash/toString';
import { Validator } from 'components/LWForm';

export const validateDomain: Validator = (domainValue) => {
	if (domainValue && !isFQDN(toString(domainValue))) {
		return 'Please enter a valid domain name';
	}
	return '';
};

export const validateSubDomain: Validator = (domainValue) => {
	if (domainValue && !isFQDN(toString(domainValue), { require_tld: false })) {
		return 'Please enter a valid subdomain name';
	}
	return '';
};

export const validateOppId: Validator = (oppId) => {
	const stringOppId = toString(oppId);
	const isValid =
		/006[A-Za-z0-9]{12,15}/.test(stringOppId) && stringOppId.length <= 18;
	return !isValid ? 'Please enter a valid opportunity ID' : '';
};

export const validatePhoneNumber: Validator = (phoneNumber) => {
	const stringPhoneNumber = toString(phoneNumber);
	const isValid = /^[0-9extnsio.,()+ -]{2,25}$/i.test(stringPhoneNumber);
	return !isValid ? 'Please enter phone number in a valid format' : '';
};
